module.exports = __webpack_public_path__ + "img/AI.bd87d5df.png";